module.exports = __webpack_public_path__ + "static/media/Ninetales_gaussian2.6f68ce29.png";